import React, { useState } from 'react';
import styled from 'styled-components';
import { Accordion, AccordionTitle, AccordionContent, AccordionItem, ButtonTertiary, cssColorValue, IconArrowRight, KeyboardDetectionProvider, makeColorSetClass, spacer8, spacer24, spacer32, spacer40, spacer48, screenMdMin, screenXxsMax, Type, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, Grid, ResponsiveType, TWO_COLUMN_MAX_WIDTH, withAnimationContext, } from '../../ui';
import { fixHref, formatText } from '../../ui/utils';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
const AccordionContainer = styled(Grid) `
  height: auto;
  padding-top: ${spacer40};
  padding-bottom: ${spacer48};

  @media (max-width: ${screenXxsMax}) {
    display: block;
    padding-top: ${spacer40};
    padding-bottom: ${spacer32};
  }
`;
const Headline = withAnimationContext(styled(ResponsiveType).attrs({
    typeAs: 'h1',
    variantDesktop: 'brio',
    variantMobile: 'alto',
    paddingBottom: '0.67em',
    weight: 'bold',
}) `
  ${fadeInAnimation(DELAYS.FIRST)};
  padding-bottom: ${spacer32};
  line-height: normal;
  grid-column: 1 / 10;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
  }

  @media (max-width: ${screenMdMin}) {
    padding-bottom: ${spacer24};
    text-align: left;
  }
`);
const CTAContainer = withAnimationContext(styled.div `
    ${fadeInAnimation(DELAYS.THIRD)};
    display: flex;
    grid-column: 1 / 12;

    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      grid-column: 1 / -1;
    }
    @media (max-width: ${screenXxsMax}) {
      width: 100%;
      padding-top: 0px;
    }
  `);
const StyledAccordion = withAnimationContext(styled(Accordion) `
  ${fadeInAnimation(DELAYS.SECOND)};
  grid-column: 1 / 13;
  padding-block-end: var(--spacer-0, ${spacer24});

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    grid-column: 1 / -1;
  }
`);
const StyledButtonTertiary = styled(ButtonTertiary) `
  color: ${cssColorValue('textBase')};
  padding: 0px;
`;
const StyledCtaText = styled.span `
  padding-right: ${spacer8};
`;
export const AccordionModule = React.forwardRef(({ headline, ctaLink, ctaText, btnComponent, items = [], colors, themeName = 'light', }, ref) => {
    const [activeIndex, updateActive] = useState(-1);
    const useColors = (colors === null || colors === void 0 ? void 0 : colors.backgroundColor) && (colors === null || colors === void 0 ? void 0 : colors.textColor);
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement(AccordionContainer, { ref: ref, className: (!useColors &&
                    makeColorSetClass(themeName === 'light' ? 'base' : 'invertedDark')) ||
                    '' },
                React.createElement(Headline, { "data-testid": "accordion-headline" }, headline),
                React.createElement(StyledAccordion, { "aria-label": "Accordion group for FAQs" }, items.map((item, index) => (React.createElement(AccordionItem, { key: `${index}-item` },
                    React.createElement(AccordionTitle, { key: `${index}-title`, onClick: e => {
                            e.preventDefault();
                            updateActive(index === activeIndex ? -1 : index);
                        }, isExpanded: index === activeIndex }, item.title),
                    React.createElement(AccordionContent, { isExpanded: index === activeIndex },
                        React.createElement(Type, { variant: "ballad", dangerouslySetInnerHTML: {
                                __html: formatText(item.content),
                            } })))))),
                ctaText && ctaLink && (React.createElement(CTAContainer, null,
                    React.createElement(StyledButtonTertiary, { href: fixHref(ctaLink) || '', component: btnComponent, buttonSize: "sm" },
                        React.createElement(StyledCtaText, null, ctaText),
                        React.createElement(IconArrowRight, { iconSize: 16 }))))))));
});
